"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setAdminInstruction = void 0;
const api_1 = require("./api");
/**
 * Generate instruction to set admin of the treasury.
 *
 * @type {Object} args - Arguments on instruction creation
 * @param param {IncentivesDistributionProgram} args.program - anchor program instance
 * @param param {PublicKey} args.treasuryAccount - treasury account address
 * @param param {PublicKey} args.oldAdminAuthority - admin authority [SIGNER] (when not provided loaded from treasury account)
 * @param param {PublicKey} args.newAdminAuthority - admin authority to be assigned to treasury
 * @type {Object} return - Return data of generated instruction
 * @return {TransactionInstruction} return.instruction - Instruction to set admin of the treasury
 */
async function setAdminInstruction({ program, treasuryAccount, oldAdminAuthority, newAdminAuthority, }) {
    if (!oldAdminAuthority) {
        const treasuryData = await (0, api_1.treasury)({ program, address: treasuryAccount });
        oldAdminAuthority = treasuryData.adminAuthority;
    }
    const instruction = await program.methods
        .setAdmin(newAdminAuthority)
        .accountsStrict({
        treasuryAccount,
        adminAuthority: oldAdminAuthority,
    })
        .instruction();
    return { instruction };
}
exports.setAdminInstruction = setAdminInstruction;
//# sourceMappingURL=setAdminInstruction.js.map